import { Button } from "components/Button/Button";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { dataIsAvailable, dateFormat } from "utils";
import { Input, Select, TextArea } from "components/Form";
import ReactSelect from "react-select";
import DeleteIcon from "@mui/icons-material/Delete";

import {
    addFreeCourseAccess,
    addStudentPersonalizedLecturesbyCourse,
    deleteAssignedPersonalizedLecture,
    getCoursesViaStudentEmail,
    getLectureViaStudentEmail,
    getPersonalizedLectureListofCourse,
    getPersonalizedLectures,
} from "services/student/studentController";
import CourseModal from "./Sections/CourseModal";
import ModalBox from "components/modal/ModalBox";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import CommentBankIcon from "@mui/icons-material/CommentBank";
import Paper from "@mui/material/Paper";
import CommentRow from "./CommentRow";
import { useSearchParams } from "react-router-dom";
import BulkCourseModal from "./Sections/BulkCourseModal";
import { getMasterSubjects, getMasterSubSubjects } from "services/master";
import { Checkbox } from "@mui/material";

const StudentPersonalizedLecturesbyCourse = () => {
    const [searchParam, setSearchParam] = useSearchParams();
    let activePage = +searchParam.get("page") || 1;
    let search = searchParam.get("query") || "";
    const [page, setPage] = useState(activePage);

    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [submitButtonElement2, setSubmitLoading2] = useMuiButtonLoader();
    const [userEmail, setUserEmail] = useState(search || "");
    const [lecturesearch, setlecturesearch] = useState("");
    const [selectedCourseId, setSelectedCourseId] = useState("");
    const [userData, setUserData] = useState({});

    const [confirmModal, setConfirmModal] = useState(false);
    const [revokeModal, setRevokeModal] = useState(false);
    const [commentModal, setCommentModal] = useState(false);
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState("");
    const [allComments, setAllComments] = useState([]);
    const [allSubjects, setAllSubjects] = useState([]);
    const [allSubSubjects, setAllSubSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState("");
    const [selectedSubSubject, setSelectedSubSubject] = useState(null);
    const [selectedId, setSelectedId] = useState([]);
    const [selectedlectureId, setSelectedLectureId] = useState("");
    const [allLectureids, setAllLectureids] = useState([]);
    const [selectedLectures, setSelectedLectures] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteButtonElement, setDeleteLoading] = useMuiButtonLoader();


    const [record, setRecord] = useState([]);
    const [total, setTotal] = useState(0);

    const [loader, showLoader, hideLoader] = useFullPageLoader();

    //   search courses by student email
    const fetchLectures = async (pageNumber) => {
        showLoader();

        const finalData = {
            accessType: "normal",
            search: userEmail,
            page: pageNumber,
            // subjectid: selectedSubject?.value || "",
            // subsubjectid: selectedSubSubject?.value || "",
            lectureSearch: lecturesearch,
            // courseid: selectedCourse?.value,
        };

        try {
            const res = await getPersonalizedLectureListofCourse(finalData);
            hideLoader();

            if (res.code === 200) {
                setRecord(res.data.lectures?.rows || []);
                setTotal(res.data.lectures?.count || 0);
                setUserData(res.data.studentdetails || {});
            } else {
                setRecord([]);
                setTotal(0);
                toast.error(res.message);
            }
        } catch (err) {
            hideLoader();
            toast.error(err.message);
        }
    };

    const searchHandler = async (e) => {
        e.preventDefault();

        if (!userEmail) {
            toast.error("Please enter email/phone and select course");
            return;
        }

        // 👇 DO NOT RESET PAGE HERE
        searchParam.set("query", userEmail);
        searchParam.set("page", page);
        setSearchParam(searchParam);

        fetchLectures(page);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
        searchParam.set("page", newPage);
        setSearchParam(searchParam);

        fetchLectures(newPage);
    };


    useEffect(() => {
        setSearchParam({});
        setUserEmail("");
        setRecord([]);
        setTotal(0);
        setUserData({});
    }, []);

    const resetFilter = async () => {
        // Clear lecture search and dropdowns
        setlecturesearch("");
        setSelectedSubject("");
        setSelectedSubSubject(null);

        // Reset page and query param
        setSearchParam({});

        // Fetch the lectures again for the student without filters
        if (userEmail) {
            try {
                showLoader();
                const finalData = {
                    accessType: "normal",
                    search: userEmail,
                    page: 1, // reset page
                    subjectid: "",
                    subsubjectid: "",
                };
                const res = await getPersonalizedLectureListofCourse(finalData);
                hideLoader();

                if (res.code === 200) {
                    setRecord(res.data.lectures?.rows || []);
                    setTotal(res.data.lectures?.count || 0);
                } else {
                    setRecord([]);
                    setTotal(0);
                    toast.error(res.message);
                }
            } catch (err) {
                hideLoader();
                toast.error(err?.response?.data?.message || err.message);
            }
        }
    };



    // --------------- getting all required masters data ----------------//
    useLayoutEffect(() => {
        const getSubjectsData = async () => {
            try {
                const res = await getMasterSubjects();
                if (res.code === 200) {
                    setAllSubjects(res.data.subjectMaster.rows || []);
                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            }
        };

        getSubjectsData();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!selectedSubject?.value) return;

        const getSubSubjects = async () => {
            try {
                const res = await getMasterSubSubjects({
                    subject_id: selectedSubject.value,
                });

                if (res.code === 200) {
                    setAllSubSubjects(res.data.subSubjectMaster.rows || []);
                }
            } catch (err) {
                toast.error(err.message);
            }
        };

        getSubSubjects();
    }, [selectedSubject]);


    const subjectOptions = allSubjects.map((s) => ({
        value: s.id,
        label: s.name,
    }));

    const subSubjectOptions = allSubSubjects.map((s) => ({
        value: s.id,
        label: s.name,
    }));

    const deletePersonalizedLecture = async () => {
        console.log("selected", selectedlectureId, selectedCourseId);

        if (!selectedlectureId || !selectedCourseId) return;

        try {
            setDeleteLoading(true);

            const res = await deleteAssignedPersonalizedLecture({
                lectureid: selectedlectureId,
                studentid: userData.UserID,
                courseid: selectedCourseId
            });

            if (res.code === 200) {
                toast.success(res.message);
                setDeleteModal(false);
                setSelectedLectureId("");
                setSelectedCourseId("");
                fetchLectures(page);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        } finally {
            setDeleteLoading(false);
        }
    };


    return (
        <React.Fragment>
            <title>Shubhra Viraj | Lecture Access List</title>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="SearchBox"></div>
                            <h4 className="Title">Student Personalized Lectures by Course</h4>
                        </div>
                        <div className=" mt-3">
                            <form onSubmit={searchHandler}>
                                <div className="row align-items-center">
                                    <div className="col-md-8">
                                        <Input
                                            className="form-control"
                                            placeholder="Enter User Email Address or Phone"
                                            value={userEmail}
                                            onChange={({ target }) => setUserEmail(target.value)}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <Button type="submit" {...submitButtonElement}>
                                            Search
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    {Object.keys(userData).length > 0 && (
                        <div className="Small-Wrapper" style={{ marginTop: "10px" }}>
                            <h5 className="mb-3">Student Details</h5>
                            {Object.keys(userData).length > 0 && (
                                <div className="TableList overflow-auto table-responsive p-0">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Student Name</th>
                                                <th>Email ID</th>
                                                <th>Mobile</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Object.keys(userData).length > 0 ? (
                                                <tr key={userData.UserID}>
                                                    <td>1</td>
                                                    <td>
                                                        {dataIsAvailable(userData.firstName)}{" "}
                                                        {dataIsAvailable(userData.lastName)}
                                                    </td>
                                                    <td>{dataIsAvailable(userData.EmailID)}</td>
                                                    <td>{dataIsAvailable(userData.Mobile)}</td>

                                                </tr>
                                            ) : (
                                                <NotFound cols={4} />
                                            )}
                                        </tbody>
                                    </table>

                                </div>

                            )}

                        </div>
                    )}

                    {Object.keys(userData).length > 0 && (
                        <div className="Small-Wrapper" style={{ marginTop: "10px" }}>

                            <h5 className="mb-3">Assigned Lectures</h5>

                            {/* Search & Filters Row */}
                            <div
                                className="search_wrap"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    flexWrap: "wrap",
                                    marginBottom: "15px",
                                }}
                            >
                                {/* 1️⃣ Lecture Search Input */}
                                <Button className="refresh_btnn mx-1" onClick={resetFilter}>
                                    <i className="fa fa-refresh"></i>
                                </Button>

                                <Button
                                    className="mx-1"
                                    onClick={searchHandler}
                                    {...submitButtonElement}
                                >
                                    Search
                                </Button>

                                {/* 5️⃣ Reset Button */}

                                {/* 3️⃣ Sub-Subject Dropdown */}




                                <div style={{ minWidth: "100px", flex: "1 1 200px" }} >
                                    <Input
                                        className="form-control"
                                        placeholder="Search Here"
                                        value={lecturesearch}
                                        onChange={({ target }) => setlecturesearch(target.value)}
                                        type="text"
                                    />
                                </div>

                                {/* 4️⃣ Search Button */}

                            </div>

                            {loader}



                            {/* Lecture Table */}
                            <div className="TableList overflow-auto table-responsive p-0">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>

                                            <th>S.No</th>
                                            <th>Lecture Title</th>
                                            <th>Course</th>
                                            <th>Platform</th>
                                            <th>Expiry Date</th>
                                            <th>Action</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {record.length > 0 ? (
                                            record.map(
                                                (
                                                    { LectureID, lectureid, lecturetitle, course, courseid, duration, platform, speciallectures, subject, subSubject, expiredate },
                                                    i
                                                ) => (
                                                    <tr key={LectureID}>

                                                        <td>{i + 1 + (activePage - 1) * 10}</td>
                                                        {/* <td>{dataIsAvailable(lecturetitle)}</td> */}
                                                        <td
                                                            style={{
                                                                maxWidth: "300px",        // adjust width as needed
                                                                whiteSpace: "normal",     // allow wrapping
                                                                wordBreak: "break-word",  // break long words
                                                                overflowWrap: "anywhere" // modern safe wrap
                                                            }}
                                                        >
                                                            {dataIsAvailable(lecturetitle)}
                                                        </td>
                                                        {/* <td>{dataIsAvailable(course)}</td> */}
                                                        <td
                                                            style={{
                                                                maxWidth: "300px",        // adjust width as needed
                                                                whiteSpace: "normal",     // allow wrapping
                                                                wordBreak: "break-word",  // break long words
                                                                overflowWrap: "anywhere" // modern safe wrap
                                                            }}
                                                        >
                                                            {dataIsAvailable(course)}
                                                        </td>

                                                        <td>{dataIsAvailable(platform)}</td>
                                                        <td>
                                                            {dateFormat(expiredate)}

                                                        </td>
                                                        <td>
                                                            <IconButton
                                                                aria-label="view"
                                                                className="px-2 py-0"
                                                                onClick={() => {
                                                                    setSelectedLectureId(lectureid);
                                                                    setSelectedCourseId(courseid);
                                                                    setDeleteModal(true);
                                                                }}
                                                            >
                                                                <DeleteIcon sx={{ color: "#ff0000" }} />
                                                            </IconButton>
                                                        </td>

                                                    </tr>
                                                )
                                            )
                                        ) : (
                                            <NotFound cols={5} />
                                        )}
                                    </tbody>
                                </table>
                            </div>





                            {/* Pagination */}
                            {total > 10 && (
                                <div className="Pagination mt-3">
                                    <Pagination
                                        activePage={activePage}
                                        itemsCountPerPage={10}
                                        totalItemsCount={total}
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange}
                                    />
                                </div>
                            )}
                        </div>
                    )}


                </div>
            </div>


            {/* revoke course access */}
            <ModalBox
                status={revokeModal}
                onClose={() => {
                    setRevokeModal(false);
                    setComment("");
                    setCommentError("");
                }}
                title={"Revoke Course"}
                description={"Are you sure want to revoke course access ?"}
                customizedFooter={
                    <Button
                        //onClick={() => assignCourseHandler("remove")}
                        {...submitButtonElement2}
                    >
                        Yes
                    </Button>
                }
            >
                <div className="form-group row mt-1">
                    <div className="col-sm-12 col-form-label ">
                        <TextArea
                            type="text"
                            name="comment"
                            value={comment}
                            onChange={({ target }) => setComment(target.value)}
                            placeholder="Enter Comment"
                            className={`form-control `}
                            label={"Comment"}
                            error={commentError}
                            required
                            maxLength={200}
                            rows={7}
                            disabled={submitButtonElement2.disabled}
                        />
                    </div>
                </div>
            </ModalBox>

            <ModalBox
                status={deleteModal}
                onClose={() => setDeleteModal(false)}
                title={"Delete Lecture"}
                description={"Are you sure want to delete this lecture access?"}
                customizedFooter={
                    <Button onClick={deletePersonalizedLecture} {...deleteButtonElement}>
                        Yes
                    </Button>
                }
            />


        </React.Fragment>
    );
};

export default StudentPersonalizedLecturesbyCourse;
